import { render } from "./QuestionType.vue?vue&type=template&id=4075a3d0"
import script from "./QuestionType.vue?vue&type=script&lang=js"
export * from "./QuestionType.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__